import React from 'react';
import { Link } from 'react-router-dom';

const BASE_BUTTON_CLASSES =
  'inline-flex items-center justify-center rounded-lg border px-3 py-1.5 text-sm font-semibold shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:pointer-events-none disabled:opacity-50';

const VARIANT_CLASSES = {
  neutral:
    'border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50 focus:ring-slate-200',
  edit:
    'border-amber-200 bg-amber-50 text-amber-700 hover:border-amber-300 hover:bg-amber-100 focus:ring-amber-200',
  success:
    'border-emerald-200 bg-emerald-50 text-emerald-700 hover:border-emerald-300 hover:bg-emerald-100 focus:ring-emerald-200',
  danger:
    'border-red-200 bg-red-50 text-red-700 hover:border-red-300 hover:bg-red-100 focus:ring-red-200',
};

export function getActionButtonClasses(variant = 'neutral') {
  return `${BASE_BUTTON_CLASSES} ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.neutral}`;
}

export function ActionButton({ variant = 'neutral', className = '', children, ...props }) {
  return (
    <button
      className={`${getActionButtonClasses(variant)} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}

export function ActionLink({ variant = 'neutral', className = '', children, ...props }) {
  return (
    <Link
      className={`${getActionButtonClasses(variant)} ${className}`.trim()}
      {...props}
    >
      {children}
    </Link>
  );
}

export function ActionButtonGroup({ align = 'right', className = '', children }) {
  const alignmentClass =
    align === 'left' ? 'justify-start' : align === 'center' ? 'justify-center' : 'justify-end';

  return (
    <div className={`flex flex-wrap items-center gap-2 ${alignmentClass} ${className}`.trim()}>
      {children}
    </div>
  );
}

export function StatusToggle({
  checked,
  onChange,
  disabled = false,
  label,
  onLabel = 'Active',
  offLabel = 'Inactive',
  showStateLabel = true,
  className = '',
}) {
  const stateLabel = checked ? onLabel : offLabel;

  return (
    <div className={`inline-flex items-center gap-2 ${className}`.trim()}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label || stateLabel}
        onClick={onChange}
        disabled={disabled}
        className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 ${
          checked
            ? 'border-emerald-300 bg-emerald-500/80'
            : 'border-slate-300 bg-slate-200'
        }`}
      >
        <span
          className={`inline-block h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200 ${
            checked ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      {showStateLabel && (
        <span
          className={`text-xs font-semibold ${
            checked ? 'text-emerald-700' : 'text-slate-500'
          }`}
        >
          {stateLabel}
        </span>
      )}
    </div>
  );
}
